import { SupabaseClient } from '@supabase/supabase-js';
import { UserRepository } from './repositories/UserRepository';
import { ClassRepository } from './repositories/ClassRepository';
import { StudentRepository } from './repositories/StudentRepository';
import { HomeworkRepository } from './repositories/HomeworkRepository';
import { SemesterRepository } from './repositories/SemesterRepository';
import { CacheRepository } from './repositories/CacheRepository';
import { StorageRepository } from './repositories/StorageRepository';

/**
 * Main database service that provides access to all repositories
 * This creates a centralized access point while preserving all existing functionality
 */
export class DatabaseService {
  public readonly user: UserRepository;
  public readonly class: ClassRepository;
  public readonly student: StudentRepository;
  public readonly homework: HomeworkRepository;
  public readonly semester: SemesterRepository;
  public readonly cache: CacheRepository;
  public readonly storage: StorageRepository;

  constructor(supabase: SupabaseClient<any, 'public', any>) {
    this.user = new UserRepository(supabase);
    this.class = new ClassRepository(supabase);
    this.student = new StudentRepository(supabase);
    this.homework = new HomeworkRepository(supabase);
    this.semester = new SemesterRepository(supabase);
    this.cache = new CacheRepository(supabase);
    this.storage = new StorageRepository(supabase);
  }
}

/**
 * Factory function to create a DatabaseService instance
 * This maintains the same pattern as existing utility functions
 */
export const createDatabaseService = (
  supabase: SupabaseClient<any, 'public', any>,
): DatabaseService => {
  return new DatabaseService(supabase);
};

// Re-export types for convenience
export * from './types';
export type { DatabaseResult, DatabaseArrayResult } from './BaseRepository';
